import { useState } from "react"
import { getAISEO } from "../api/api"

export default function AISEO() {
  const [domain, setDomain] = useState("")
  const [result, setResult] = useState(null)

  async function run() {
    const res = await getAISEO(domain)
    setResult(res.data)
  }

  return (
    <div className="page">
      <h1>AI SEO Optimizer</h1>
      <div className="card form-row">
        <label>
          Domain
          <input value={domain} onChange={(e) => setDomain(e.target.value)} placeholder="example.com" />
        </label>
        <button onClick={run}>Load suggestions</button>
      </div>
      {result && <pre>{JSON.stringify(result, null, 2)}</pre>}
    </div>
  )
}
